import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Select from "react-select";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { AddUserGroup } from "./modal"
import { EditRole } from "./editModal"
import { Footer } from "../../../layout/footer"
import { options } from "../../../api";
import { authCRUD } from "../../../actions/auth"
import { toast } from "react-toastify"

export const UserGroupContent = () => {

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0)
  const [value, setValue] = useState('')
  const [index, setIndex] = useState(0)
  const [selectedRole, setSelectedRole] = useState(null)
  const [mode, setMode] = useState('view')

  useEffect(() => {
    setLoading(true)
    authCRUD.loadGroups(postsPerPage, nextPage, value).then((resp) => {
      setCount(resp.data.count)
      setData(resp.data.results)
      setPageCount(Math.ceil(resp.data.count / postsPerPage))
    }).finally(() => {
      setLoading(false)
    })
  }, [page, postsPerPage, value, index])

  const handleChangePage = (event) => {
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = selectedOption => {
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0)
  };

  const handleSearch = (event) => {
    setValue(event.target.value)

  }

  const handleDelete = (dt) => {
    if (!window.confirm(`Delete role "${dt.name}"? This cannot be undone.`)) return
    authCRUD.deleteGroup(dt.id)
      .then(() => {
        toast.success('Role deleted.', { autoClose: 5000 })
        setIndex(index + 1)
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || error?.message || 'Delete failed', { autoClose: 7000 })
      })
  }

  return (

    <>
      {loading &&
        <div>
          <div className="loading"></div>
        </div>
      }
      <AddUserGroup setIndex={setIndex} index={index} />
      <EditRole role={selectedRole} mode={mode} setIndex={setIndex} index={index} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Roles &amp; Permissions</h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="#">Groups</a></li>
                      <li className="breadcrumb-item active">List</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <input className="form-control" value={value} onChange={handleSearch} placeholder="search" />
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          <div className="col-auto">
                            <Link to={'/new'} className="btn btn-soft-primary" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg">
                              <i className="bi bi-plus-circle bi-lg"></i> &nbsp; New User Group
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table id="scroll-vertical" className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">Role Name</th>
                          <th data-ordering="true">Permissions</th>
                          <th data-ordering="true">Users</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          data?.map((dt, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{dt.name ? dt.name : 'N/A'}</td>
                              <td>
                                {(dt.capabilities && dt.capabilities.length) ? (
                                  dt.capabilities.map((c) => (
                                    <span key={c} className="badge bg-soft-primary text-primary me-1 mb-1">
                                      {c.replace(/_/g, ' ')}
                                    </span>
                                  ))
                                ) : (
                                  <span className="text-muted">No permissions</span>
                                )}
                              </td>
                              <td>
                                <span className="badge bg-soft-secondary text-secondary">{dt.user_count ?? 0}</span>
                              </td>
                              <td className="text-center">
                                <div className="hstack gap-2 justify-content-center fs-15">
                                  <button
                                    title="View"
                                    className="btn btn-sm btn-soft-info"
                                    data-bs-toggle="modal"
                                    data-bs-target=".editRoleModal"
                                    onClick={() => { setSelectedRole(dt); setMode('view') }}
                                  >
                                    <i className="bi bi-eye"></i>
                                  </button>
                                  <button
                                    title="Edit"
                                    className="btn btn-sm btn-soft-warning"
                                    data-bs-toggle="modal"
                                    data-bs-target=".editRoleModal"
                                    onClick={() => { setSelectedRole(dt); setMode('edit') }}
                                  >
                                    <i className="bi bi-pencil-square"></i>
                                  </button>
                                  <button
                                    title="Delete"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => handleDelete(dt)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    <div className="row">
                      <div className="col-md-2">
                        <p><span>Showing </span><span>{data.length}</span> of <span>{count}</span> entries</p>
                      </div>
                      <div className="col-md-5">

                      </div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select options={options} defaultValue={options[1]} onChange={handleChange} />
                          </div>
                          <div className="col-auto paginate" >
                            <ReactPaginate
                              previousLabel={<i className="las la-angle-double-left la-lg"></i>}
                              nextLabel={<i className="las la-angle-double-right la-lg"></i>}
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Footer />
      </div>
    </>

  )

}